(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-product-2025"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", e => {
   const swiper_thumb = new Swiper(".swiper-container2", {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
    });
    const swiper_main = new Swiper(".swiper-container", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".media-gallery_swiper-button-next",
        prevEl: ".media-gallery_swiper-button-prev",
      },
      thumbs: {
        swiper: swiper_thumb,
      },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valentines_2026"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // When in view

          entry.target.classList.add('animate-price');
        }
         //else {
         // // Optional: remove class to animate again when scrolling back up
         //entry.target.classList.remove('animate-price');
        //}
      });
    },
    {
      threshold: 1, // Trigger when 100% (i.e 1) of the element is visible
    }
  );

  // Target elements to observe
  const targets = document.querySelectorAll('.m4-worth-now');
  targets.forEach((target) => observer.observe(target));

  // TODO: Fix short-term hack and find a proper solution to have add-to-bag buttons with custom designs.
  // Currently, when placing the entire <product-card-form> section where a button is supposed to be, it's dimensions are bigger
  // and it is difficult to resize to fit into smaller spaces.
  // 
  // This hack sends the click from the custom button to the actual add-to-bag, the latter being invisible. (See product-card-form CSS).
  document.addEventListener('DOMContentLoaded', (dom_event) => {

    const n31_btn_actual = document.getElementById("n31-cart-btn");
    const n31_btn_fake = document.getElementById("n31-cart-fake");
    const n111_btn_actual = document.getElementById("n111-cart-btn");
    const n111_btn_fake = document.getElementById("n111-cart-fake");

    n31_btn_fake.addEventListener('click', (e) => { n31_btn_actual.click(); console.log("31 clicked"); });

    n111_btn_fake.addEventListener('click', (e) => { n111_btn_actual.click(); console.log("111 clicked"); });
  });

  } catch(e) { console.error(e); }
})();
})();
